import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import React, { Fragment, useEffect, useState } from "react";
import {
  addOwnerProfileDetails,
  updateOwnerProfileDetails,
} from "../../../../api/owner.api";
import { success } from "../../../../utils/notifications";

const initialData = {
  sameInfoAsUser: false,
  name: "",
  email: "",
  phone: "",
  address: "",
  bankInfo: {
    bankName: "",
    accountHolder: "",
    accountNumber: "",
  },
};
const ProfileDetailsPopup = ({
  open,
  setOpen,
  mode,
  profileDetails,
  ownerDetails,
  fetchOwnerProfile,
}) => {
  const [profileDetailsData, setProfileDetailsData] = useState(initialData);

  useEffect(() => {
    mode === "edit"
      ? setProfileDetailsData(profileDetails)
      : setProfileDetailsData(initialData);
  }, [mode, profileDetails]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "sameInfoAsUser" && checked) {
      const fullName = `${ownerDetails.firstName} ${ownerDetails.lastName}`;
      setProfileDetailsData({
        ...profileDetailsData,
        ...ownerDetails,
        name: fullName,
        sameInfoAsUser: checked,
      });
    } else {
      setProfileDetailsData({
        ...profileDetailsData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (mode === "edit") {
      updateOwnerProfileDetails(ownerDetails.ownerId, profileDetailsData)
        .then((res) => {
          console.log(res?.data);
          setOpen(false);
          success("Updated", "Owner Details updated Successfully");
          fetchOwnerProfile();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      addOwnerProfileDetails(profileDetailsData)
        .then((res) => {
          console.log(res?.data);
          setProfileDetailsData(initialData);
          setOpen(false);
          success("Updated", "Owner Details updated Successfully");
          fetchOwnerProfile();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="z-50" onClose={setOpen}>
        <Transition.Child
          enter="ease-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-300"
          leaveFrom="opacity-100 transform scale-100"
          leaveTo="opacity-0 transform scale-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-500"
              enterFrom="opacity-0 transform scale-0"
              enterTo="opacity-100 transform scale-100"
              leave="ease-in duration-300"
              leaveFrom="opacity-100 transform scale-100"
              leaveTo="opacity-0 transform scale-0"
            >
              <Dialog.Panel className="mt-12 lg:ml-60 md:ml-60 ml-0 z-50 lg:w-1/2 md:w-1/2 w-4/5 fixed mx-auto rounded-lg bg-white pt-5 pb-4 text-left shadow-xl transition-all h-auto">
                <div className="absolute top-0 right-0 pt-4 pr-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                    onClick={() => setOpen(false)}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="">
                  <div className=" sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="px-3 pb-5 text-xl font-semibold border-b-2 border-gray-200 leading-6 text-gray-900"
                    >
                      Owner Profile Details
                    </Dialog.Title>
                    <div className="">
                      <form onSubmit={handleSubmit} method="POST">
                        <div className="h-96 overflow-y-scroll">
                          <div className="px-7 py-4">
                            <div className="flex items-center justify-between">
                              <div>
                                <h2 className="text-xl font-semibold text-gray-300 ">
                                  Company Details
                                </h2>
                              </div>
                              <div>
                                <div className="flex items-center">
                                  <input
                                    id="sameInfoAsUser"
                                    name="sameInfoAsUser"
                                    type="checkbox"
                                    value={profileDetailsData.sameInfoAsUser}
                                    onChange={handleChange}
                                    className="h-4 w-4 rounded border-gray-300 text-yellow focus:ring-yellow"
                                  />
                                  <label
                                    htmlFor="sameInfoAsUser"
                                    className="text-base ml-3 block font-medium leading-6 text-gray-300"
                                  >
                                    Same as Profile Information
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="py-3 md:py-4 lg:py-4">
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="name"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Company Name
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="name"
                                      placeholder="Enter Company Name"
                                      value={profileDetailsData.name}
                                      onChange={handleChange}
                                      id="name"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="phone"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Company Phone
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="phone"
                                      placeholder="Enter Company Name"
                                      value={profileDetailsData.phone}
                                      onChange={handleChange}
                                      id="phone"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="email"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Company Email
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="email"
                                      placeholder="Enter Company Email"
                                      value={profileDetailsData.email}
                                      onChange={handleChange}
                                      id="email"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="address"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Company Address
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="address"
                                      placeholder="Enter Company Address"
                                      value={profileDetailsData.address}
                                      onChange={handleChange}
                                      id="address"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="flex items-center justify-between">
                              <div>
                                <h2 className="text-xl font-semibold text-gray-300">
                                  Bank Account Details
                                </h2>
                              </div>
                            </div>
                            <div className="py-3 md:py-4 lg:py-4">
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="bankName"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Bank Name
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="bankName"
                                      placeholder="Enter Bank Name"
                                      value={
                                        profileDetailsData.bankInfo.bankName
                                      }
                                      onChange={(e) =>
                                        setProfileDetailsData((bankData) => ({
                                          ...bankData,
                                          bankInfo: {
                                            ...bankData.bankInfo,
                                            bankName: e.target.value,
                                          },
                                        }))
                                      }
                                      id="bankName"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="bankInfo.accountHolder"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Account Holder Name
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="accountHolder"
                                      placeholder="Enter Account Holder Name"
                                      value={
                                        profileDetailsData.bankInfo
                                          .accountHolder
                                      }
                                      onChange={(e) =>
                                        setProfileDetailsData((bankData) => ({
                                          ...bankData,
                                          bankInfo: {
                                            ...bankData.bankInfo,
                                            accountHolder: e.target.value,
                                          },
                                        }))
                                      }
                                      id="accountHolder"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="bankInfo.accountNumber"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Banck Account Number
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="accountNumber"
                                      placeholder="Enter Account Number"
                                      value={
                                        profileDetailsData.bankInfo
                                          .accountNumber
                                      }
                                      onChange={(e) =>
                                        setProfileDetailsData((bankData) => ({
                                          ...bankData,
                                          bankInfo: {
                                            ...bankData.bankInfo,
                                            accountNumber: e.target.value,
                                          },
                                        }))
                                      }
                                      id="accountNumber"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="border-t-2 border-gray-200 px-7 pt-3 flex items-center justify-end">
                          <button
                            type="submit"
                            className="flex justify-center rounded-md bg-yellow px-3 py-2.5 px-10 text-base font-semibold leading-6 text-dark shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow"
                          >
                            {mode === "edit" ? "Update" : "Save"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ProfileDetailsPopup;
